import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";

/**
 * Detection order:
 *  1. localStorage (user override via switcher)
 *  2. navigator.language → if Spanish → 'es'; if English → 'en'; else fallback 'en'
 *
 * Whitelist: only 'es' and 'en'. Any region tag (es-MX, es-ES, en-US) is normalized
 * to the base language by `load: 'languageOnly'`.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    fallbackLng: "en",
    supportedLngs: ["es", "en"],
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      convertDetectedLanguage: (lng) => {
        // Strip POSIX-style suffixes (e.g. "en-US@posix") and region tags,
        // so we always land on either "es" or "en".
        const base = String(lng || "").toLowerCase().split(/[-_@.]/)[0];
        return ["es", "en"].includes(base) ? base : "en";
      }
    },
    interpolation: { escapeValue: false },
    returnObjects: true
  });

// Keep <html lang="..."> in sync with the active language (good for SEO).
const syncHtmlLang = (lng) => {
  if (typeof document !== "undefined" && lng) {
    const base = String(lng).toLowerCase().split("-")[0];
    document.documentElement.lang = base === "es" ? "es-MX" : "en-US";
  }
};
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
